export default `
/*
    默认 post 请求
    需在组件 index.vue 的 props 中引入   utils: Object
    发送请求
    例：
    引入： import $http from "../../../../http"
    使用：
        $http(this,{
            url: "event_list",     // api文件中的key
            data: {},
        }).then( res => {})
*/

import api from "./api.js";

export default (vm, data) => {
  let url = vm.utils.transformURL(api[data.url] || data.url);
  if (url.indexOf("serv") === -1) url = "/serv/" + url;
  let query = JSON.stringify(data.data) || JSON.stringify({ param: 0 });
  let method = "post";
  if (data.method) method = data.method;
  if (data.method === "get") query = data.data || { param: 0 };
  let params = {
    url,
    data: query,
    method,
    headers: {
      ["Content-Type"]: "application/json;charset=UTF-8",
    },
  };
  return new Promise((resolve, reject) => {
    vm.$proxy(params)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

`


// WEBPACK FOOTER //
// ./src/pages/frontProJect/code/http.js